import { Empty, Typography } from 'antd';
import React, { ReactNode } from 'react';

import ACButton from 'ac-components/ac-button/ACButton';
import NoResultsIcon from 'ac-components/ac-icons/NoResultsIcon';
import RefreshIcon from 'ac-components/ac-icons/RefreshIcon';

import './WidgetEmpty.less';

type Props = {
  description?: string | ReactNode;
  onRetry?: () => void;
};

export const NO_DATA_AVAILABLE = 'Nothing matches your search';

export const WidgetEmpty = ({
  description = NO_DATA_AVAILABLE,
  onRetry,
}: Props) => {
  return (
    <div className="ac-empty-widget d-flex align-items-center justify-content-center h-100">
      <Empty
        description={
          <>
            <Typography.Text style={{ color: '#5C5C5C' }}>
              {description}
            </Typography.Text>
            {onRetry && (
              <div className="m-t-sm">
                <ACButton type="outline" size="sm" onClick={onRetry}>
                  <div className="d-flex m-r-xs">
                    <RefreshIcon /> Refresh
                  </div>
                </ACButton>
              </div>
            )}
          </>
        }
        image={<NoResultsIcon />}
      />
    </div>
  );
};
